// src/globalState.js
import { hookstate } from '@hookstate/core';

export const globalUserState = hookstate({});
export const globalLoadingState = hookstate(true);

